export default __webpack_public_path__ + "static/8_29-602cea4a70230f37f8bcdad737598f31.png";